import { Form } from "common/Forms";
import { Checkbox } from "common/Forms/inputs";
import { TableRenderer } from "common/Table";
import { userRoles } from "Constant/Constant";

const buildGroupedRows = (rows) => {
  if (!Array.isArray(rows)) return [];
  const grouped = {};
  const groupOrder = [];
  rows.forEach((row) => {
    const group = row.groupTitle ?? "Other";
    if (!grouped[group]) {
      grouped[group] = [];
      groupOrder.push(group);
    }
    grouped[group].push(row);
  });

  const result = [];
  groupOrder.forEach((group) => {
    result.push({ __isGroupHeader: true, group });
    result.push(...grouped[group]);
  });
  return result;
};

export const TableView = ({ rows = [], onToggle }) => {
  const groupedRows = buildGroupedRows(rows);

  const columns = [
    {
      name: "Actions / Permissions",
      headerRenderer: (col) => <div className="text-base">{col.name}</div>,
      bodyRenderer: (x) => <div>{x?.name ?? "-"}</div>,
    },
    {
      name: "Admin",
      classNames: ["!text-center"],
      headerRenderer: (col) => <div className="w-full text-center text-base">{col.name}</div>,
      bodyRenderer: (x) => (
        <div className="flex justify-center">
          <Checkbox
            id={`admin-${x?.id ?? "row"}`}
            name={`admin-${x?.id ?? "row"}`}
            value={Boolean(x?.roles?.includes(userRoles.ADMIN))}
            disabled={true}
            onChange={() => { }}
          />
        </div>
      ),
    },
    {
      name: "Sales Manager",
      classNames: ["!text-center"],
      headerRenderer: (col) => <div className="w-full text-center text-base">{col.name}</div>,
      bodyRenderer: (x) => (
        <div className="flex justify-center">
          <Checkbox
            id={`sales-manager-${x?.id ?? "row"}`}
            name={`sales-manager-${x?.id ?? "row"}`}
            value={Boolean(x?.roles?.includes(userRoles.SALES_MANAGER))}
            onChange={() => onToggle(x.id, userRoles.SALES_MANAGER)}
          />
        </div>
      ),
    },
    {
      name: "Sales Person",
      classNames: ["!text-center"],
      headerRenderer: (col) => <div className="w-full text-center text-base">{col.name}</div>,
      bodyRenderer: (x) => (
        <div className="flex justify-center">
          <Checkbox
            id={`sales-person-${x?.id ?? "row"}`}
            name={`sales-person-${x?.id ?? "row"}`}
            value={Boolean(x?.roles?.includes(userRoles.SALES_PERSON))}
            onChange={() => onToggle(x.id, userRoles.SALES_PERSON)}
          />
        </div>
      ),
    },
  ];

  return (
    <Form>
      <TableRenderer
        data={groupedRows}
        columns={columns}
        rowRendenderer={(x, _i, cols) => {
          if (x.__isGroupHeader) {
            return (
              <tr key={`group-${x.group}`} className="bg-primary-table_header_bg">
                <td
                  colSpan={cols.length}
                  className="px-4 py-2 text-sm font-semibold text-gray-600 uppercase tracking-wide">
                  {x.group}
                </td>
              </tr>
            );
          }
          return (
            <tr key={x.id} className="border-t">
              {cols.map((col) => (
                <td
                  key={col.name}
                  className={["py-4 px-4 text-left text-sm", ...(col.classNames ?? [])].join(" ")}>
                  {col.bodyRenderer(x)}
                </td>
              ))}
            </tr>
          );
        }}
      />
    </Form>
  );
};
